
import ALL_CHARACTERS from './all.json';

export default ALL_CHARACTERS;